import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
	Modal,
	Button,
	Form,
	Row,
	ToggleButtonGroup,
	ToggleButton,
	ButtonGroup,
	Col,
} from 'react-bootstrap';

import { joinQueue } from '../../redux/actions/socketActions';

export default function LobbyPopup({ show, handleClose, choice }) {
	//
	const [queueOptions, setQueueOptions] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		console.log(queueOptions);
	}, [queueOptions]);
	//
	const handlePlay = (event) => {
		console.log(choice);
		//
		dispatch(joinQueue(queueOptions));
		// redirect to room
	};
	return (
		<Modal
			show={show}
			onHide={handleClose}
			// backdrop="static"
			keyboard={true}
			centered
			animation={false}
		>
			<Modal.Header closeButton>
				<Modal.Title>Settings..</Modal.Title>
			</Modal.Header>
			<ModalBody choice={choice} setQueueOptions={setQueueOptions} />
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>
					Go Back
				</Button>
				<Button variant="info" onClick={handlePlay}>
					Play
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

LobbyPopup.propTypes = {
	show: PropTypes.bool,
	handleClose: PropTypes.func,
	choice: PropTypes.string,
};

function ModalBody({ choice, setQueueOptions }) {
	const [gameModeValue, setGameModeValue] = useState('1'); // classic or standard
	const [gameTypeValue, setGameTypeValue] = useState('1'); // 1vs1 or 2vs2
	const [turnDurationValue, setTurnDurationValue] = useState('1');
	const [roundValue, setRoundValue] = useState('1');
	const [url, setUrl] = useState('');
	const [iberValue, setIberValue] = useState('1');
	const [cheatingValue, setCheatingValue] = useState('1');

	useEffect(() => {
		updateQueueOptions();
		//
	}, [
		gameModeValue,
		gameTypeValue,
		turnDurationValue,
		roundValue,
		url,
		iberValue,
		cheatingValue,
	]);

	const updateQueueOptions = () => {
		switch (choice) {
			case 'random':
				setQueueOptions({
					mode: getName(gameModes, gameModeValue),
					gameType: getName(gameTypes, gameTypeValue),
				});
				break;

			case 'url':
				setQueueOptions({ roomURL: url });
				break;

			case 'new':
				setQueueOptions({
					newRoom: true,
					mode: getName(gameModes, gameModeValue),
					gameType: getName(gameTypes, gameTypeValue),
					turnDuration: getName(turnDurations, turnDurationValue),
					rounds: getName(rounds, roundValue),
					iber: getName(ibers, iberValue) === 'enabled' ? true : false,
					cheating: getName(cheatings, cheatingValue) === 'allowed' ? true : false,
				});
				break;

			default:
				console.log('default here..');
		}
	};

	const getName = (objects, val) => {
		return objects.find((obj) => obj.value === val).name;
	};

	const gameTypes = [
		{ name: 'classic', value: '1' },
		{ name: 'standard', value: '2' },
	];
	const gameModes = [
		{ name: '1vs1', value: '1' },
		{ name: '2vs2', value: '2' },
	];
	const turnDurations = [
		{ name: '10s', value: '1' },
		{ name: '15s', value: '2' },
		{ name: '20s', value: '3' },
	];
	const rounds = [
		{ name: '6', value: '1' },
		{ name: '11', value: '2' },
		{ name: '21', value: '3' },
	];
	const ibers = [
		{ name: 'enabled', value: '1' },
		{ name: 'disabled', value: '2' },
	];
	const cheatings = [
		{ name: 'allowed', value: '1' },
		{ name: 'not allowed', value: '2' },
	];

	if (choice === 'url')
		return (
			<div>
				<Modal.Body>
					<Form>
						<Form.Control
							className="mb-2 mr-sm-2"
							id="inlineFormInputName2"
							placeholder="Enter room url.."
							onChange={(e) => {
								setUrl(e.target.value);
							}}
						/>
					</Form>
				</Modal.Body>
			</div>
		);

	if (choice === 'new')
		return (
			<div>
				<Modal.Body>
					<Form>
						{/* modes */}
						<Row>
							<Col xs={4}>Game Type</Col>
							<Col>
								{' '}
								<ButtonGroup className="toggle-group" toggle>
									{gameTypes.map((gameType, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="gameType"
											value={gameType.value}
											checked={gameTypeValue === gameType.value}
											onChange={(e) => {
												setGameTypeValue(e.currentTarget.value);
											}}
										>
											{gameType.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>

						{/* gameModesSS */}
						<Row>
							<Col xs={4}>Game Mode</Col>
							<Col>
								<ButtonGroup className="toggle-group" toggle>
									{gameModes.map((gameMode, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="gameMode"
											value={gameMode.value}
											checked={gameModeValue === gameMode.value}
											onChange={(e) => {
												setGameModeValue(e.currentTarget.value);
											}}
										>
											{gameMode.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>

						{/* turnDurations */}
						<Row>
							<Col xs={4}>Turn Duration</Col>

							<Col>
								<ButtonGroup className="toggle-group" toggle>
									{turnDurations.map((turnDuration, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="turnDuration"
											value={turnDuration.value}
											checked={turnDurationValue === turnDuration.value}
											onChange={(e) => {
												setTurnDurationValue(e.currentTarget.value);
											}}
										>
											{turnDuration.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>

						{/* rounds */}
						<Row>
							<Col xs={4}>Points</Col>
							<Col>
								<ButtonGroup className="toggle-group" toggle>
									{rounds.map((round, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="round"
											value={round.value}
											checked={roundValue === round.value}
											onChange={(e) => {
												setRoundValue(e.currentTarget.value);
											}}
										>
											{round.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>

						{/* Iber */}
						<Row>
							<Col xs={4}>Iber</Col>
							<Col>
								<ButtonGroup className="toggle-group" toggle>
									{ibers.map((iber, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="iber"
											value={iber.value}
											checked={iberValue === iber.value}
											onChange={(e) => {
												setIberValue(e.currentTarget.value);
											}}
										>
											{iber.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>

						{/* Iber */}
						<Row>
							<Col xs={4}>Cheating</Col>
							<Col>
								<ButtonGroup className="toggle-group" toggle>
									{cheatings.map((cheating, idx) => (
										<ToggleButton
											className="toggle-btn"
											key={idx}
											type="checkbox"
											variant="light"
											name="cheating"
											value={cheating.value}
											checked={cheatingValue === cheating.value}
											onChange={(e) => {
												setCheatingValue(e.currentTarget.value);
											}}
										>
											{cheating.name}
										</ToggleButton>
									))}
								</ButtonGroup>
							</Col>
						</Row>
					</Form>
				</Modal.Body>
			</div>
		);
	return (
		<div>
			<Modal.Body>
				<Form>
					<Row>
						<Col xs={4}>Game Type</Col>
						<Col>
							{' '}
							<ButtonGroup className="toggle-group" toggle>
								{gameTypes.map((gameType, idx) => (
									<ToggleButton
										className="toggle-btn"
										key={idx}
										type="checkbox"
										variant="light"
										name="gameType"
										value={gameType.value}
										checked={gameTypeValue === gameType.value}
										onChange={(e) => {
											setGameTypeValue(e.currentTarget.value);
										}}
									>
										{gameType.name}
									</ToggleButton>
								))}
							</ButtonGroup>
						</Col>
					</Row>

					{/* gameModesSS */}
					<Row>
						<Col xs={4}>Game Mode</Col>
						<Col>
							<ButtonGroup className="toggle-group" toggle>
								{gameModes.map((mode, idx) => (
									<ToggleButton
										className="toggle-btn"
										key={idx}
										type="checkbox"
										variant="light"
										name="mode"
										value={mode.value}
										checked={gameModeValue === mode.value}
										onChange={(e) => {
											setGameModeValue(e.currentTarget.value);
										}}
									>
										{mode.name}
									</ToggleButton>
								))}
							</ButtonGroup>
						</Col>
					</Row>
				</Form>
			</Modal.Body>
		</div>
	);
}
